module.exports = __webpack_public_path__ + "img/check-circle-green.0b7c5dee.svg";